import { makeStyles } from '@mui/styles';
import Accordion from 'apollo-react/components/Accordion';
import AccordionDetails from 'apollo-react/components/AccordionDetails';
import AccordionSummary from 'apollo-react/components/AccordionSummary';
import Table from 'apollo-react/components/Table';
import Typography from 'apollo-react/components/Typography';
import React, { useState } from 'react';

import { createCustomCell } from '../../components/SavedSearchesTable/utils';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';

const useStyles = makeStyles({
  root: {
    border: 'solid 1px #e9e9e9',
    boxShadow: 'none',
    width: '100%',
  },
  gridHeader: {
    fontWeight: 600,
    color: 'black',
    fontSize: 14,
  },
});

const PreRequisites = ({ columns, rows, totalRecordCount = 0, entityName = '', ...props }) => {
  const classes = useStyles();

  const { isMobileDevice } = useWindowDimensions();
  const [collapsed, setCollapsed] = useState(isMobileDevice);

  const handleChange = () => {
    setCollapsed((collapsed) => !collapsed);
  };

  return (
    <div ui-ta="ScrollingElement">
      <div ui-ta="SSPanel">
        <Accordion defaultExpanded={!collapsed} expanded={!collapsed} onChange={handleChange}>
          <AccordionSummary>
            <Typography>
              <span className={classes.gridHeader}>{`${entityName} (${totalRecordCount})`}</span>
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ paddingRight: 0 }}>
            <Table
              classes={{ root: classes.root }}
              columns={columns.map((column) => ({
                ...column,
                customCell: createCustomCell(column),
              }))}
              rows={rows}
              tablePaginationProps={{ dir: 'ltr' }}
              {...props}
            />
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default PreRequisites;
